import * as types from '../constants/ActionTypes';

const initialState = {
   currentBookKey: null,
   currentArticleKey: null,
   bookData: null,
   isBookDataFetching: false,
   bookDataCache: {},
   listLeafs: [],
   listLeafKeyToIndexMap: {},
   booksData: null,
   isBooksDataFetching: false,
   articleData: null,
   isArticleDataFetching: false,
   articleDataCache: {},
   statusText: null
};

export default function data(state = initialState, action) {
   const {type, payload} = action;
   switch (type) {
      case types.FETCH_DATA_FAILURE:
         return Object.assign({}, state, {
            'statusText': `Fetch Data Error: ${payload.status} ${payload.statusText}`
         });

      case types.FETCH_BOOKS_DATA_REQUEST:
         return Object.assign({}, state, {
            'isBooksDataFetching': true
         });

      case types.RECEIVE_BOOKS_DATA:
         return Object.assign({}, state, {
            'booksData': payload.booksData,
            'isBooksDataFetching': false
         });

      case types.FETCH_BOOKS_DATA_FAILURE:
         return Object.assign({}, state, {
            'booksData': null,
            'isBooksDataFetching': false
         });

      case types.FETCH_BOOK_DATA_REQUEST:
         return Object.assign({}, state, {
            'isBookDataFetching': true
         });

      case types.RECEIVE_BOOK_DATA:
         return Object.assign({}, state, {
            'bookDataCache': payload.bookDataCache
         });

      case types.SET_BOOK_DATA:
         return Object.assign({}, state, {
            'bookData': payload.bookData,
            'listLeafs': payload.listLeafs,
            'listLeafKeyToIndexMap': payload.listLeafKeyToIndexMap,
            'currentBookKey': payload.currentBookKey,
            'currentArticleKey': payload.currentArticleKey,
            'isBookDataFetching': false
         });

      case types.SET_CURRENT_BOOK_KEY:
         return Object.assign({}, state, {
            'currentBookKey': payload.currentBookKey
         });

      case types.FETCH_BOOK_DATA_FAILURE:
         return Object.assign({}, state, {
            'bookData': null,
            'listLeafs': [],
            'listLeafKeyToIndexMap': null,
            'isBookDataFetching': false
         });

      case types.FETCH_ARTICLE_DATA_REQUEST:
         return Object.assign({}, state, {
            'isArticleDataFetching': true
         });

      case types.RECEIVE_ARTICLE_DATA:
         return Object.assign({}, state, {
            'articleDataCache': payload.dataCache,
            'isArticleDataFetching': false
         });

      case types.SET_ARTICLE_DATA:
         return Object.assign({}, state, {
            'articleData': payload.articleData
         });

      case types.SET_CURRENT_ARTICLE_KEY:
         return Object.assign({}, state, {
            'currentArticleKey': payload.currentArticleKey
         });

      case types.FETCH_ARTICLE_DATA_FAILURE:
         return Object.assign({}, state, {
            'isArticleDataFetching': false,
            'articleData': null
         });

      default:
         return state;
   }
}



// WEBPACK FOOTER //
// ./src/reducers/data.js